enum UserRole {
    ROLE_CLIENT = 'ROLE_CLIENT',
    ROLE_OPERATOR = 'ROLE_OPERATOR',
    ROLE_OPERATOR_SUPERVISOR = 'ROLE_OPERATOR_SUPERVISOR',
    ROLE_ADMIN = 'ROLE_ADMIN',
    ROLE_STOREKEEPER = 'ROLE_STOREKEEPER',
}

export default UserRole;
